// Picks up a new deploy on the launch that finds it, instead of the one after.
//
// src/sw.ts calls skipWaiting() + clients.claim(), so a new service worker
// takes control the moment it installs — usually a second or two after the
// app opens, when the browser checks sw.js. The page that is open was built
// from the OLD precache, though, and keeps running old JS/CSS until reloaded.
//
// Reload once, but ONLY in the first few seconds after launch, before a
// teacher can have typed anything. Teachers do long, unsaved work here —
// marks entry, a test being built, a check-in with the camera open — so,
// unlike the parent app, there is no "reload while backgrounded" path: a
// backgrounded teacher may be in the file picker or the camera with a form
// underneath. An update that lands mid-session is simply picked up on the
// next launch, which the new service worker then serves directly.
// The first install (no previous controller) is not an update and never reloads.

const LAUNCH_WINDOW_MS = 6000;

if ("serviceWorker" in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  let reloading = false;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController || reloading) return;
    if (performance.now() >= LAUNCH_WINDOW_MS) return;
    reloading = true;
    window.location.reload();
  });
}
